import { createServerClient } from '@supabase/ssr';
import { createClient as createSupabaseClient } from '@supabase/supabase-js';

/**
 * Server-side Supabase Client (Admin)
 *
 * Uses SERVICE_ROLE_KEY to bypass RLS for admin operations.
 * For user authentication, use the auth middleware instead.
 */
export function createClient() {
  return createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.SUPABASE_SERVICE_ROLE_KEY!
  );
}

/**
 * Server-side Supabase Client with Cookie-based Auth (Next.js 15 compatible)
 *
 * Use this for API routes that need user authentication.
 * Properly handles async cookies in Next.js 15.
 */
export async function createAuthClient() {
  // Lazy import to avoid Next.js pages/ directory error
  const { cookies } = await import('next/headers');
  const cookieStore = await cookies();

  return createServerClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          return cookieStore.getAll();
        },
        setAll(cookiesToSet) {
          try {
            cookiesToSet.forEach(({ name, value, options }) => {
              cookieStore.set(name, value, options);
            });
          } catch {
            // Called from Server Component - cookies cannot be modified
          }
        },
      },
    }
  );
}
